<template>
<b-row class="hypertension disease-pages no-gutters">
  <b-col class="tool-border" cols="12">
    <b-col class="reduce-padding" cols="12">
      <wlpHeader :pageTitle="pageTitle" :pageImage="pageImage"></wlpHeader>
    </b-col>
    
    <b-col class="page-background-gradient reduce-padding" cols="12">
      <b-row class="page-content  no-gutters">
        <b-row class="body-sec no-gutters">
          <b-col class="reduce-padding top-section" cols="12">
            <b-row class="no-gutters">
              <b-col class="reduce-padding text-section" lg="8" md="8" cols="12">
                <div v-if="!userData.conditions.hypten">
                  <div class="top-text-title bold-text">
                    {{$t('common.top-text-title')}}
                  </div>
                  <div class="top-text bottom-spacing" :class="{'bottom-spacing-sp' : $i18n.locale=='sp'}">{{$t('hypertension.top-text')}}
                  </div>
                </div>

                <div v-if="userData.conditions.hypten">
                  <div class="top-text-title bold-text">{{$t('common.top-text-title2')}}</div>
                  <div class="top-text" :class="{'top-text-sp' : $i18n.locale=='sp'}">
                    {{$t('hypertension.top-text2')}}
                  </div>
                </div>
              </b-col>
              <b-col class="reduce-padding check-section" lg="4"  md="4"   cols="12">
                <b-row class="check-yes-section hyp-check no-gutters">
                  <div class="condition-checkboxes  wlp-checkboxes">
                  <input @change="toggleAdjButtons()" type="checkbox" name="htnCondition" v-model="userData.conditions.hypten" id="htnCondition" value="htnCondition">
                  <label class="" for="htnCondition">
                      <div class="condition-label">{{$t('hypertension.condition-label-1')}} <br> {{$t('hypertension.condition-label-2')}} <br> {{$t('hypertension.condition-label-3')}}</div>
                  </label>
                </div>
                </b-row>
              </b-col>
            </b-row>
            <div class="top-hr"></div>
          </b-col>
          <b-col class="reduce-padding graph-col" lg="8" md="7" cols="12">
            <div class="graph-title">
              <b-col class="reduce-padding" cols="12">
                <div class="" v-if="userData.conditions.hypten">
                  <b-row class="bp-field-space no-gutters">
                    <b-col md="7" class="reduce-padding">
                      <div class="fields-head"  :class="{'fields-head-sp': $i18n.locale=='sp'}" >{{$t('hypertension.inputFields')}} <span class="unbold" > (mm Hg):</span></div>
                    </b-col>
                      <b-col md="5" class=" bp-div reduce-padding">
                        <div class="systolicBp-field " :class="{'haserror': ( submittedHtn &&  ((!$v.userData.systolicBp.required || !$v.userData.systolicBp.numeric || 
                    !$v.userData.systolicBp.minLength || !$v.userData.systolicBp.maxLength || 
                    !$v.userData.systolicBp.between) || ( userData.systolicBp < userData.diastolicBp)) ) }">
                    <input @change="updatebars()" class="common-feilds systolicBp" name="systolicBp" type="text" v-model.number="userData.systolicBp" maxLength="3" placeholder="90+" :class="{'greytxt': this.$v.userData.systolicBp.$invalid ||  userData.systolicBp < userData.diastolicBp }">
                  </div>
                  <div class="slash"> &#47; </div>
                  <div class="diastolicBp-field" :class="{'haserror': ( submittedHtn && ( (!$v.userData.diastolicBp.required || !$v.userData.diastolicBp.numeric || 
                    !$v.userData.diastolicBp.minLength || !$v.userData.diastolicBp.maxLength || 
                    !$v.userData.diastolicBp.between) || ( userData.systolicBp < userData.diastolicBp) )) }">
                    <input @change="updatebars()" class="common-feilds diastolicBp" name="diastolicBp" type="text" v-model.number="userData.diastolicBp" maxLength="3" placeholder="50+" :class="{'greytxt': this.$v.userData.diastolicBp.$invalid ||  userData.systolicBp < userData.diastolicBp }">
                  </div>
                    </b-col>
                  </b-row>
                    <b-row class="hyperlipidemia-graph-title bold-text no-gutters">
                  <div class="validation-div"  :class="{'validation-div-sp': $i18n.locale=='sp'}" >
                       <div class="validation-txt" v-if="((submittedHtn &&  (!$v.userData.systolicBp.required || !$v.userData.systolicBp.numeric || 
                      !$v.userData.systolicBp.minLength || !$v.userData.systolicBp.maxLength || !$v.userData.systolicBp.between ) )  || ( submittedHtn &&  (!$v.userData.diastolicBp.required || !$v.userData.diastolicBp.numeric || 
                      !$v.userData.diastolicBp.minLength || !$v.userData.diastolicBp.maxLength || !$v.userData.diastolicBp.between ) ))" >{{$t('error.error-required4')}}</div>
                  </div>
                  <div class="main-valid-div" >
                   <div class="validation-div2" >
                       <div class="validation-txt2" v-if="!((submittedHtn &&  (!$v.userData.systolicBp.required || !$v.userData.systolicBp.numeric || 
                      !$v.userData.systolicBp.minLength || !$v.userData.systolicBp.maxLength || !$v.userData.systolicBp.between ) )  
                      || ( submittedHtn &&  (!$v.userData.diastolicBp.required || !$v.userData.diastolicBp.numeric || !$v.userData.diastolicBp.minLength || !$v.userData.diastolicBp.maxLength 
                      || !$v.userData.diastolicBp.between ) )) && (submittedHtn && ( userData.systolicBp < userData.diastolicBp))">{{$t('hypertension.error')}}</div>
                  </div>
                  </div>
                  <div class="bargraph-heading">{{$t('hypertension.graphTitle')}}
                  <div class=" unbold"><span v-if="userData.adjustButtons.hypten>0">{{userData.adjustButtons.hypten}}% {{$t('graph.lineGraphSubTitle')}} </span>(mm Hg)</div></div>
                </b-row>
                </div> 
                <div v-if="!userData.conditions.hypten">
                  <div class="graph-title graph-title-space graph-title-common bold-text">
                  {{$t('graph.lineGraphTitle')}} {{$t('common.hypertension2')}} (≥140/90)
                </div>
                <div class="graph-sub-title graph-title-common">
                  <span v-if="userData.adjustButtons.hypten>0">{{userData.adjustButtons.hypten}}% {{$t('graph.lineGraphSubTitle')}} </span>(%)
                </div>
                </div>
              </b-col>
            </div>
            <div class="graphs-div">
              <div class="bar-graph-div" v-if="userData.conditions.hypten">
                <barGraph :disease="'hypten'" :barValues="userData.calc.hyptenBP" :adjustSelection="userData.adjustButtons.hypten" 
                :displayBars="(this.userData.systolicBp>=90 && this.userData.systolicBp<300 && this.userData.diastolicBp>=50 && this.userData.diastolicBp<200 && this.userData.diastolicBp<this.userData.systolicBp)" 
                :lblY=lblY :lblEndX="200" :lblStartX="50" :lblSkipX="10"></barGraph>
              </div>
              <div v-if="!userData.conditions.hypten">
                <lineChart :disease="'hypertension'" :risk="userData.calc.hypten" :adjustSelection="userData.adjustButtons.hypten" :lblEndX="40" :lblSkipX="1" 
                :lblStartY="-5" :lblEndY="50" :lblSkipY="5" :confInt="this.userData.confInt.hypten"></lineChart>
              </div>
            </div>
            <b-col v-if="!userData.conditions.hypten" class="graph-bottom hypertension-graph-bottom" cols="12">
              <b-row class="no-gutters">
                <b-col class="reduce-padding legends order-lg-1 order-2" lg="4" cols="12">
                  <b-row class=" no-gutters">
                        <b-col class="reduce-padding risk-bullets" md="4" lg="6" cols="12">
                          <div class="bullet blue"></div>
                          <div class="bullet-text" :class="{'bullet-text-sp' : $i18n.locale=='sp'}">{{$t('common.currentRisk')}}</div>
                        </b-col>
                        <b-col class="reduce-padding risk-bullets" md ="8" lg="6" cols="12">
                          <div class="bullet green" v-if="userData.adjustButtons.hypten>0" md="6" ></div>
                          <div class="bullet-text" :class="{'bullet-text-sp' : $i18n.locale=='sp'}" v-if="userData.adjustButtons.hypten>0"  md="6" >{{$t('common.adjustedRisk')}}</div>
                        </b-col>
                      </b-row>
                </b-col>
                <b-col class="reduce-padding x-label-title order-lg-2 order-1" lg="2" cols="12">
                  <div class="">{{$t('common.bmi')}}</div>
                </b-col>
              </b-row>
            </b-col>
            <b-col class=" graph-bottom hyper-bar-graph-bottom bar-graph-bottom" v-if="userData.conditions.hypten">
              <b-row class="no-gutters">
                  <div class="bottom-section-hyper  " :class="{'bottom-section-hyper-sp' : $i18n.locale=='sp'}" v-show="this.userData.systolicBp>=90 && this.userData.systolicBp<300 && this.userData.diastolicBp>=50 && this.userData.diastolicBp<200 && this.userData.diastolicBp<this.userData.systolicBp">
                      <div class ="weight-loss-txt before-loss">
                        <div class="bullet blue"></div>
                        <div class="bullet-text" :class="{'bullet-text-sp' : $i18n.locale=='sp'}">{{$t('common.beforeWeight')}}</div>
                      </div>
                      <div class ="weight-loss-txt after-loss">
                        <div class="bullet green" v-if="userData.adjustButtons.hypten>0"></div>
                        <div class="bullet-text" :class="{'bullet-text-sp' : $i18n.locale=='sp'}" v-if="userData.adjustButtons.hypten>0">{{$t('common.afterWeight')}}</div>
                      </div>  
                  </div>
              
              </b-row>
            </b-col>
          </b-col>
          <b-col class="reduce-padding adj-weight-col" md="4" cols="12">
            <b-row class=" top-extra-space no-gutters">
              <b-col class="triangle-outer reduce-padding" cols="12">
                <div class="triangle-img"></div>
              </b-col>
              <b-col class="htn-adj-box reduce-padding">
                <weightAdjustmentBox id="weightAdjBox" :disease="diseaseName" :condition="userData.conditions.hypten" :adjButtons="adjButtonsArray" :adjustSelection="userData.adjustButtons.hypten" 
                :btnClickHandler="btnClickHandler()" @adjustPercUpdate="userData.adjustButtons.hypten=$event"></weightAdjustmentBox>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-row>
      <wlpNavigation :navButtons="['info','references','tnc','menu','back','next']" :currentScreen="5" :btnClickHandler="this.handleSubmit"></wlpNavigation>
    </b-col>
  </b-col>
</b-row>
</template>
<script>
/* eslint-disable */
  import scrollMixin from "../mixins/scrollMixin";
  import wlpHeader from '../components/wlpHeader.vue';
  import wlpNavigation from '../components/wlpNavigation.vue';
import lineChart from '../components/lineChart.vue';
import barGraph from '../components/barGraph.vue';
import weightAdjustmentBox from '../components/weightAdjustmentBox.vue';
import { mapGetters, mapMutations } from 'vuex';
import { required, maxLength, numeric, minLength, between } from "vuelidate/lib/validators";

  export default {
    name: "hypertension",
    mixins: [scrollMixin],
    components: {
    'wlpHeader': wlpHeader,
    'wlpNavigation': wlpNavigation,
    'lineChart': lineChart,
    'weightAdjustmentBox': weightAdjustmentBox, 
    'barGraph': barGraph,
    },
    
         validations: {
      userData: {
        systolicBp: {
          required,
          numeric,
          minLength: minLength(2),
          maxLength: maxLength(3),
          between: between(90, 299)
        },

        diastolicBp: {
          required,
          numeric,
          minLength: minLength(2),
          maxLength: maxLength(3),
          between: between(50, 199)  
        },

       }

    },


    data() {
      return {
        pageTitle: this.$t('common.hypertension'),
        diseaseName: this.$t('common.hypertension').toLowerCase(),
        pageImage: 'hypertension-img',
        htnBP: {
          current:['',''],
          adj5: ['',''],
          adj10: ['',''], 
        },
        submittedHtn: false,
        lblY: [this.$t('hypertension.ylabel1'),this.$t('hypertension.ylabel2')],
      
        adjButtonsArray: ['five', 'ten', 'fifteen', 'twenty'],
      };
    },
    computed: {
    ...mapGetters('userData', ['userData']),
  },
  
    mounted: function() {
      this.scrollToTop();
      // this.toggleAdjButtons();
      this.adjButtonsArray = this.userData.conditions.hypten?  ['five'] : ['five', 'ten', 'fifteen', 'twenty'];
      this.markSectionComplete({section:'hypten'});
     // this.setValues();
    },
    
    methods: {
      ...mapMutations('userData', ['saveCalculations', 'markSectionComplete']),
      
        handleSubmit() {
        this.submittedHtn = true;
        this.$v.$touch();
        // console.log("this.$v.$invalid ", this.$v.$invalid)
        // console.log("this.$v ", this.$v)
    
        if ((this.userData.conditions.hypten  && this.$v.$invalid) || (this.userData.conditions.hypten  && this.userData.systolicBp <= this.userData.diastolicBp)) {
          console.log("INNNNNNNNNNNNNN");
          this.scrollToError();
          return false;
        }
        
        return true;
      },
      btnClickHandler: function() {
        console.log("in handler");
        if (this.userData.adjustButtons.hypten &&((this.userData.conditions.hypten  && this.$v.$invalid) || (this.userData.conditions.hypten  && this.userData.systolicBp <= this.userData.diastolicBp))) {
         this.submittedHtn = true;
         this.scrollToError();
        }
      },
      
    
      
      htnBars: function (systolicBp, diastolicBp, adj) {
       var value= [systolicBp-(0.6*adj), diastolicBp-(0.4*adj)];
      // console.log('HTN CALC for '+adj+' : '+value);
       return value;
      },
      updatebars: function () {
        if(this.userData.systolicBp>=90 && this.userData.systolicBp<300 && this.userData.diastolicBp>=50 && this.userData.diastolicBp<200 && this.userData.diastolicBp<this.userData.systolicBp) {
          this.htnBP = {
            current: [this.userData.systolicBp, this.userData.diastolicBp],
            adj5: this.htnBars(this.userData.systolicBp, this.userData.diastolicBp, 5),
            adj10: this.htnBars(this.userData.systolicBp, this.userData.diastolicBp, 10),
          };
          this.saveCalculations({data: this.htnBP, section: 'hyptenBP'});
        }
      },
      
      toggleAdjButtons: function() {
        this.userData.adjustButtons.hypten = this.userData.conditions.hypten? 0: this.userData.adjustButtons.hypten;
        this.adjButtonsArray = this.userData.conditions.hypten?  ['five'] : ['five', 'ten', 'fifteen', 'twenty'];
       
      },
    }
  };
</script>


<style lang="scss" scoped>
</style>
